import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import AdminSidebar from "./AdminSidebar";
import { Box } from "@mui/material";
import { useApi } from "../hooks";
import { apiGetUser, method } from "../apiPath";
import keyNames from "../keyName";
import { getToast } from "../common/utils";
const toast = getToast("error");
const AdminLayout = () => {
  const hitApi = useApi();

  const storeData = useSelector((state) => state.mainReducer);
  const { userData } = storeData;
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (!userData) {
      hitApi(apiGetUser, null, method.get, keyNames.userData, toast);
    }
  }, [userData, hitApi]);

  return (
    userData && (
      <Box className="vh-100" sx={{ display: "flex" }}>
        <Header open={open} setOpen={setOpen} />
        <AdminSidebar open={open} />
        <Box
          className="transition"
          sx={{
            ml: open ? "240px" : "66px",
            mt: "64px",
            minHeight: "calc(-64px + 100vh)",
            width: "100%",
            borderRadius: "8px 8px 0px 0px",
            backgroundColor: (theme) => `${theme.palette.primary.main}10`,
            flexGrow: 1,
            p: 3,
            overflowY: "auto",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    )
  );
};
export default AdminLayout;
